import { sessionStateStorage } from "@repo/components/src/shared/login/oauthState";

/**
 * What the register page collected before going out to Google or Microsoft, kept for
 * `/start/claim` across that round trip: the name, the phone and whether the terms were
 * accepted.
 * `sessionStorage` survives that redirect in the same tab and is gone once the tab
 * closes. Storage can be unavailable (a private window, blocked site data): the claim
 * page then asks for both itself.
 */
const KEY = "montu.start.signUp";

export type PendingSignUp = {
  firstName: string | undefined;
  lastName: string | undefined;
  phoneNumber: string | undefined;
  acceptedTerms: boolean;
};

const NOTHING_PENDING: PendingSignUp = {
  firstName: undefined,
  lastName: undefined,
  phoneNumber: undefined,
  acceptedTerms: false,
};

export const savePendingSignUp = (signUp: PendingSignUp): void => {
  try {
    sessionStateStorage()?.setItem(KEY, JSON.stringify(signUp));
  } catch {
    // The claim page asks for it instead.
  }
};

export const readPendingSignUp = (): PendingSignUp => {
  try {
    const raw = sessionStateStorage()?.getItem(KEY);
    if (!raw) return NOTHING_PENDING;
    const parsed: unknown = JSON.parse(raw);
    if (typeof parsed !== "object" || parsed === null) return NOTHING_PENDING;
    return {
      firstName:
        "firstName" in parsed && typeof parsed.firstName === "string"
          ? parsed.firstName
          : undefined,
      lastName:
        "lastName" in parsed && typeof parsed.lastName === "string"
          ? parsed.lastName
          : undefined,
      phoneNumber:
        "phoneNumber" in parsed && typeof parsed.phoneNumber === "string"
          ? parsed.phoneNumber
          : undefined,
      acceptedTerms: "acceptedTerms" in parsed && parsed.acceptedTerms === true,
    };
  } catch {
    return NOTHING_PENDING;
  }
};

export const clearPendingSignUp = (): void => {
  try {
    sessionStateStorage()?.removeItem(KEY);
  } catch {
    // Nothing to clear.
  }
};
